export default __webpack_public_path__ + "static/media/done.93508c1c.svg";